import axios from "axios";
import { adminEnvironment } from "../config/environment";

const BASE_URL = adminEnvironment.apiBaseUrl;

const axiosPublic = axios.create({
  baseURL: BASE_URL,
});

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const REQUEST_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/;

export const createRequestId = () => {
  const randomUuid =
    typeof window !== "undefined" ? window.crypto?.randomUUID?.() : undefined;
  if (randomUuid) {
    return randomUuid;
  }
  return `admin-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 14)}`;
};

export const attachRequestIdHeader = (config) => {
  const headers = config.headers || {};
  const existing =
    headers.get?.("x-request-id") ??
    headers["x-request-id"] ??
    headers["X-Request-Id"];
  const requestId =
    typeof existing === "string" && REQUEST_ID_PATTERN.test(existing)
      ? existing
      : createRequestId();

  if (typeof headers.set === "function") {
    headers.set("x-request-id", requestId);
  } else {
    headers["x-request-id"] = requestId;
  }
  config.headers = headers;
  return config;
};

export const decorateResponseErrorWithRequestId = (error) => {
  const requestId =
    error?.response?.headers?.["x-request-id"] ??
    error?.response?.data?.requestId;
  if (typeof requestId === "string" && requestId) {
    error.requestId = requestId;
    const message = error?.response?.data?.message;
    const status = Number(error?.response?.status || 0);
    if (
      typeof message === "string" &&
      !message.includes(`Reference: ${requestId}`) &&
      (status >= 500 || /contact support|support team/i.test(message))
    ) {
      error.response.data.message = `${message} Reference: ${requestId}`;
    }
  }
  return error;
};

const rejectWithRequestId = (error) => {
  decorateResponseErrorWithRequestId(error);
  return Promise.reject(error);
};

axiosPublic.interceptors.request.use(attachRequestIdHeader);
axiosPrivate.interceptors.request.use(attachRequestIdHeader);
axiosPublic.interceptors.response.use((response) => response, rejectWithRequestId);
axiosPrivate.interceptors.response.use((response) => response, rejectWithRequestId);

export default axiosPublic;
